{
  "familyId": "TIJD-DUUR",
  "questions": [
    {
      "id": "TIJD-DUUR-001",
      "familyId": "TIJD-DUUR",
      "module": "Tijd",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_duur_berekenen",
      "questionType": "multiple_choice",
      "question": "Een leraar begint de les om 09:00 en eindigt om 10:30. Hoe lang duurt de les?",
      "options": ["1 uur en 30 minuten", "1 uur", "2 uur", "30 minuten"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "timeline", "showWhen": "always",
          "data": {
            "start": 9,
            "end": 11,
            "events": [
              { "position": 9, "label": "09:00", "description": "Start les", "isHighlighted": true },
              { "position": 10, "label": "10:00" },
              { "position": 10.5, "label": "10:30", "description": "Einde les", "isHighlighted": true }
            ],
            "label": "Tijdlijn van de les"
          },
          "a11y": { "alt": "Tijdlijn: les start om 09:00 en eindigt om 10:30" }
        }
      ],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Tijdsduur berekenen", "content": "Ga naar het volgende hele uur: 09:00 → 10:00 = 1 uur. Tel de rest: 10:00 → 10:30 = 30 min. Totaal: 1 uur en 30 minuten.", "icon": "lightbulb" } }],
      "conceptId": "time_duration_lesson",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.ignores-partial-hour", "label": "Telt alleen hele uren, vergeet minuten", "optionIndex": 1 },
          { "id": "tijd.rounds-up-to-full-hour", "label": "Rondt af naar heel uur", "optionIndex": 2 },
          { "id": "tijd.counts-only-minutes", "label": "Telt alleen minuten, vergeet het hele uur", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "De leraar berekent: 09:00 → 10:00 = 1 uur. Dan 10:00 → 10:30 = 30 minuten. Totaal: 1 uur en 30 minuten.",
        "solutionSteps": ["09:00 → 10:00 = 1 uur", "10:00 → 10:30 = 30 minuten", "Totaal: 1 uur + 30 min = 1 uur en 30 minuten"],
        "distractorExplanations": {
          "0": "Goed! De les duurt 1 uur en 30 minuten.",
          "1": "Je dacht waarschijnlijk dat je alleen het hele uur telt. Maar na 10:00 zijn er nog 30 minuten tot 10:30. Onthoud: tel ook de minuten na het hele uur.",
          "2": "Je dacht waarschijnlijk dat het 2 uur is. Maar van 09:00 tot 10:30 is 1,5 uur, niet 2 uur. Onthoud: reken stap voor stap.",
          "3": "Je dacht waarschijnlijk dat alleen de minuten tellen. Maar je vergeet het hele uur van 09:00 → 10:00. Onthoud: tel eerst de uren, dan de minuten."
        }
      }
    },
    {
      "id": "TIJD-DUUR-002",
      "familyId": "TIJD-DUUR",
      "module": "Tijd",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_duur_berekenen",
      "questionType": "multiple_choice",
      "question": "Een treinmachinist vertrekt om 13:45 en komt aan om 15:20. Hoe lang duurt de reis?",
      "options": ["1 uur en 35 minuten", "1 uur en 25 minuten", "2 uur en 35 minuten", "1 uur en 45 minuten"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "timeline", "data": { "start": 13, "end": 16, "events": [ { "position": 13.75, "label": "13:45", "description": "Vertrek", "isHighlighted": true }, { "position": 14, "label": "14:00" }, { "position": 15, "label": "15:00" }, { "position": 15.33, "label": "15:20", "description": "Aankomst", "isHighlighted": true } ], "label": "Tijdlijn: vertrek (13:45) en aankomst (15:20)" }, "a11y": { "alt": "Tijdlijn: trein vertrekt 13:45, komt aan 15:20" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Tijdsduur over uurgrens", "content": "13:45 → 14:00 = 15 min. 14:00 → 15:00 = 1 uur. 15:00 → 15:20 = 20 min. Totaal: 15 + 60 + 20 = 95 min = 1 uur en 35 min.", "icon": "lightbulb" } }],
      "conceptId": "time_duration_train",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.wrong-minutes-to-hour", "label": "Berekent minuten tot het hele uur verkeerd", "optionIndex": 1 },
          { "id": "tijd.counts-too-many-hours", "label": "Telt te veel hele uren", "optionIndex": 2 },
          { "id": "tijd.addition-error-minutes", "label": "Telt deelminuten verkeerd op", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "De treinmachinist berekent stap voor stap: 13:45 → 14:00 = 15 minuten. 14:00 → 15:00 = 1 uur. 15:00 → 15:20 = 20 minuten. Totaal: 15 + 60 + 20 = 95 minuten = 1 uur en 35 minuten.",
        "solutionSteps": ["13:45 → 14:00 = 15 min", "14:00 → 15:00 = 60 min", "15:00 → 15:20 = 20 min", "Totaal: 15 + 60 + 20 = 95 min = 1 uur en 35 min"],
        "distractorExplanations": {
          "0": "Goed! De reis duurt 1 uur en 35 minuten.",
          "1": "Je dacht waarschijnlijk dat 13:45 → 14:00 maar 5 minuten is. Maar 60 − 45 = 15 minuten. Onthoud: van :45 naar het hele uur = 15 minuten.",
          "2": "Je dacht waarschijnlijk dat er 2 hele uren tussen zitten. Maar van 13:45 tot 15:20 is iets meer dan 1,5 uur. Onthoud: reken stap voor stap via de uurgrens.",
          "3": "Je dacht waarschijnlijk dat 15 + 20 = 45 minuten. Maar 15 + 20 = 35 minuten. Onthoud: tel de deelminuten nauwkeurig op."
        }
      }
    },
    {
      "id": "TIJD-DUUR-003",
      "familyId": "TIJD-DUUR",
      "module": "Tijd",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_duur_berekenen",
      "questionType": "multiple_choice",
      "question": "Een sportcoach begint de training om 14:30. De training duurt 90 minuten. Hoe laat is de training afgelopen?",
      "options": ["16:00", "15:30", "16:30", "15:00"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "timeline", "showWhen": "always",
          "data": {
            "start": 14, "end": 17,
            "events": [
              { "position": 14.5, "label": "14:30", "description": "Start training", "isHighlighted": true },
              { "position": 16, "label": "?", "description": "Einde (na 90 min)" }
            ],
            "label": "Tijdlijn training (90 min)"
          }
        }
      ],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "90 minuten omzetten", "content": "90 minuten = 1 uur en 30 minuten. 14:30 + 1 uur = 15:30, dan + 30 min = 16:00.", "icon": "lightbulb" } }],
      "conceptId": "time_duration_sports",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.ignores-partial-hour", "label": "Telt alleen 1 uur, vergeet de 30 minuten", "optionIndex": 1 },
          { "id": "tijd.minutes-to-hours-error", "label": "Denkt dat 90 minuten = 2 uur", "optionIndex": 2 },
          { "id": "tijd.counts-only-minutes", "label": "Telt alleen 30 minuten, vergeet het hele uur", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "De sportcoach berekent: 90 minuten = 1 uur en 30 minuten. 14:30 + 1 uur = 15:30. Dan 15:30 + 30 minuten = 16:00.",
        "solutionSteps": ["90 min = 1 uur + 30 min", "14:30 + 1 uur = 15:30", "15:30 + 30 min = 16:00"],
        "distractorExplanations": {
          "0": "Goed! 14:30 + 90 minuten = 16:00.",
          "1": "Je dacht waarschijnlijk dat je alleen 1 uur optelt. Maar 90 minuten = 1 uur én 30 minuten. Na 15:30 moet je nog 30 minuten bijtellen: 16:00. Onthoud: 90 min = 1,5 uur.",
          "2": "Je dacht waarschijnlijk dat 90 minuten = 2 uur. Maar 90 minuten = 1 uur en 30 minuten, niet 2 uur. Onthoud: 1 uur = 60 minuten.",
          "3": "Je dacht waarschijnlijk dat je alleen 30 minuten optelt. Maar 90 minuten = 1 uur én 30 minuten. Je vergeet het hele uur. Onthoud: 90 min = 1,5 uur."
        }
      }
    },
    {
      "id": "TIJD-DUUR-004",
      "familyId": "TIJD-DUUR",
      "module": "Tijd",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_duur_berekenen",
      "questionType": "multiple_choice",
      "question": "Een kok begint met koken om 16:15 en is klaar om 17:40. Hoe lang kookte de kok?",
      "options": ["1 uur en 25 minuten", "1 uur en 15 minuten", "1 uur en 35 minuten", "2 uur"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "timeline", "showWhen": "always",
          "data": {
            "start": 16, "end": 18,
            "events": [
              { "position": 16.25, "label": "16:15", "description": "Start koken", "isHighlighted": true },
              { "position": 17, "label": "17:00" },
              { "position": 17.67, "label": "17:40", "description": "Klaar", "isHighlighted": true }
            ],
            "label": "Tijdlijn koken"
          }
        }
      ],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Stap voor stap rekenen", "content": "16:15 → 17:00 = 45 min. 17:00 → 17:40 = 40 min. Totaal: 45 + 40 = 85 min = 1 uur en 25 min.", "icon": "lightbulb" } }],
      "conceptId": "time_duration_cooking",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.wrong-minutes-to-hour", "label": "Berekent minuten tot het hele uur verkeerd (35 i.p.v. 45)", "optionIndex": 1 },
          { "id": "tijd.addition-error-minutes", "label": "Telt deelminuten verkeerd op (45+40=95 i.p.v. 85)", "optionIndex": 2 },
          { "id": "tijd.rounds-up-to-full-hour", "label": "Rondt af naar 2 hele uren", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "De kok berekent: 16:15 → 17:00 = 45 minuten (60 − 15 = 45). Dan 17:00 → 17:40 = 40 minuten. Totaal: 45 + 40 = 85 minuten = 1 uur en 25 minuten.",
        "solutionSteps": ["16:15 → 17:00 = 45 min (60 − 15 = 45)", "17:00 → 17:40 = 40 min", "Totaal: 45 + 40 = 85 min = 1 uur en 25 min"],
        "distractorExplanations": {
          "0": "Goed! De kok kookte 1 uur en 25 minuten.",
          "1": "Je dacht waarschijnlijk dat 16:15 → 17:00 maar 35 minuten is. Maar 60 − 15 = 45 minuten. Onthoud: van :15 naar het hele uur = 45 minuten.",
          "2": "Je dacht waarschijnlijk dat 45 + 40 = 95 minuten. Maar 45 + 40 = 85 minuten = 1 uur en 25 minuten (85 − 60 = 25). Onthoud: tel nauwkeurig op.",
          "3": "Je dacht waarschijnlijk dat het 2 uur is. Maar van 16:15 tot 17:40 is iets meer dan 1 uur, niet 2 uur. Onthoud: reken stap voor stap."
        }
      }
    },
    {
      "id": "TIJD-DUUR-005",
      "familyId": "TIJD-DUUR",
      "module": "Tijd",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_duur_berekenen",
      "questionType": "multiple_choice",
      "question": "Een filmregisseur start de opnames om 14:00. De opnames duren 1 uur en 45 minuten. Hoe laat zijn de opnames klaar?",
      "options": ["15:45", "15:15", "16:00", "15:30"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "timeline", "showWhen": "always",
          "data": {
            "start": 14, "end": 16,
            "events": [
              { "position": 14, "label": "14:00", "description": "Start opnames", "isHighlighted": true },
              { "position": 15, "label": "15:00" },
              { "position": 15.75, "label": "?", "description": "Klaar (na 1u 45min)" }
            ],
            "label": "Tijdlijn opnames (1u 45min)"
          }
        }
      ],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Tijd erbij tellen", "content": "14:00 + 1 uur = 15:00. Dan + 45 minuten = 15:45.", "icon": "lightbulb" } }],
      "conceptId": "time_duration_film",
      "variantIndex": 5,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.wrong-minutes-read", "label": "Leest 15 minuten in plaats van 45", "optionIndex": 1 },
          { "id": "tijd.minutes-to-hours-error", "label": "Denkt dat 45 minuten = 1 uur", "optionIndex": 2 },
          { "id": "tijd.confuses-half-quarter", "label": "Verwart 45 minuten met 30 minuten", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "De filmregisseur berekent: 14:00 + 1 uur = 15:00. Dan 15:00 + 45 minuten = 15:45.",
        "solutionSteps": ["14:00 + 1 uur = 15:00", "15:00 + 45 min = 15:45"],
        "distractorExplanations": {
          "0": "Goed! 14:00 + 1 uur en 45 minuten = 15:45.",
          "1": "Je dacht waarschijnlijk dat je 15 minuten optelt. Maar het is 45 minuten, niet 15. Onthoud: lees het aantal minuten goed.",
          "2": "Je dacht waarschijnlijk dat 45 minuten = 1 uur. Maar 45 minuten is geen heel uur. Onthoud: 1 uur = 60 minuten.",
          "3": "Je dacht waarschijnlijk dat 45 minuten = 30 minuten. Maar 45 minuten is een kwartier meer dan een half uur. Onthoud: 45 min = 30 min + 15 min."
        }
      }
    },
    {
      "id": "TIJD-DUUR-006",
      "familyId": "TIJD-DUUR",
      "module": "Tijd",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_duur_berekenen",
      "questionType": "fill_in",
      "question": "Een zwemleraar begint de les om 14:30 en eindigt om 16:15. Hoeveel minuten duurt de zwemles?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["105"],
        "caseSensitive": false,
        "placeholder": "Typ het aantal minuten"
      },
      "stimulusAids": [
        {
          "type": "timeline", "showWhen": "always",
          "data": {
            "start": 14, "end": 17,
            "events": [
              { "position": 14.5, "label": "14:30", "description": "Start zwemles", "isHighlighted": true },
              { "position": 15, "label": "15:00" },
              { "position": 16, "label": "16:00" },
              { "position": 16.25, "label": "16:15", "description": "Einde zwemles", "isHighlighted": true }
            ],
            "label": "Tijdlijn zwemles — bereken duur in minuten"
          }
        }
      ],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Minuten berekenen", "content": "14:30 → 15:00 = 30 min. 15:00 → 16:00 = 60 min. 16:00 → 16:15 = 15 min. Totaal: 30 + 60 + 15 = 105 min.", "icon": "lightbulb" } }],
      "conceptId": "time_duration_fill_in",
      "variantIndex": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": []
      },
      "feedback": {
        "explanationText": "De zwemleraar berekent stap voor stap: 14:30 → 15:00 = 30 minuten. 15:00 → 16:00 = 60 minuten. 16:00 → 16:15 = 15 minuten. Totaal: 30 + 60 + 15 = 105 minuten.",
        "solutionSteps": ["14:30 → 15:00 = 30 min", "15:00 → 16:00 = 60 min", "16:00 → 16:15 = 15 min", "Totaal: 30 + 60 + 15 = 105 min"]
      }
    }
  ]
}